import * as React from "react";

import type { DesignaliProps } from "../../types";

export const AiSetting = React.forwardRef<SVGSVGElement, DesignaliProps>(
  ({ ...props }, forwardedRef) => {
    return (
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="24"
        height="24"
        viewBox="0 0 24 24"
        fill="none"
        stroke="currentColor"
        strokeWidth={2}
        strokeLinecap="round"
        strokeLinejoin="round"
        {...props}
        ref={forwardedRef}
      >
        <path d="M17.72,19.7c-.06-.25-.26-.44-.51-.51l-2.17-.56c-.09-.03-.15-.12-.12-.22.02-.06.06-.11.12-.12l2.17-.56c.25-.06.44-.26.51-.51l.56-2.17c.03-.09.12-.15.22-.12.06.02.11.06.12.12l.56,2.17c.06.25.26.44.51.51l2.17.56c.09.03.15.12.12.22-.02.06-.06.11-.12.12l-2.17.56c-.25.06-.44.26-.51.51l-.56,2.17c-.03.09-.12.15-.22.12-.06-.02-.11-.06-.12-.12l-.56-2.17Z" />
        <path
          fill="none"
          d="M18.95,11.75c0-.72.38-1.38,1-1.74l.15-.09c.95-.55,1.28-1.77.73-2.73l-.22-.38c-.55-.95-1.77-1.28-2.73-.73l-.15.08c-.62.36-1.38.36-2,0l-.43-.25c-.62-.36-1-1.02-1-1.73v-.18c0-1.1-.9-2-2-2h-.44c-1.1,0-2,.9-2,2v.18c0,.71-.38,1.37-1,1.73l-.43.25c-.62.36-1.38.36-2,0l-.15-.08c-.96-.55-2.18-.22-2.73.73l-.22.38c-.55.96-.22,2.18.73,2.73l.15.1c.62.36,1,1.01,1,1.72v.51c0,.72-.38,1.38-1,1.74l-.15.09c-.95.55-1.28,1.77-.73,2.73l.22.38c.55.95,1.77,1.28,2.73.73l.15-.08c.62-.36,1.38-.36,2,0l.43.25c.62.36,1,1.02,1,1.73v.18c0,1.1.9,2,2,2h.44c.4,0,.78-.12,1.1-.33"
        />
        <circle cx="12.08" cy="12" r="3" />
      </svg>
    );
  },
);

export default AiSetting;
